import React from 'react';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@material-ui/core/styles';
import {Translate} from "../../../config/Translate";
import AppAnimate from "../../components/AppAnimate";
import Grid from "@material-ui/core/Grid/Grid";
import MakeYourFirstProduct from "./components/MakeYourFirstProduct";
import withWidth from "@material-ui/core/withWidth/withWidth";
import {withSnackbar} from "notistack";
import {withRouter} from "react-router";
import {Link} from "react-router-dom";
import {connect} from "trim-redux";
import SellerGuidLine from "./components/SellerGuidLine";
import OrdersChart from "../../components/charts/OrdersChart";
import SellerAnalyticsShort from "./components/SellerAnalyticsShort";
import BestSellingProducts from "./components/BestSellingProducts";
import UserGuidLine from "./user_components/UserGuidLine";
import ViewYourOrders from "./components/ViewYourOrders";
import Alert from "@material-ui/lab/Alert/Alert";
import Button from "@material-ui/core/Button/Button";


class UserDashboard extends React.Component {
    classes = this.props.classes;
    render(){
        let {user} = this.props;
        return (
            <AppAnimate animation='transition.slideUpIn' delay={200} title={Translate.dashboard}>
                <Grid container spacing={2} justify="center">
                    <Grid item xs={12}>
                        <Alert severity="info" variant="outlined"
                               action={
                            <Button
                                color="secondary"
                                size="small"
                                variant="contained"
                                component={Link}
                                to="/my-shop"
                                className="blink_me"
                                style={{color:'#fff',whiteSpace:"nowrap"}}
                            >
                                {Translate.becomeSeller}
                           </Button>
                        }
                        >
                            {Translate.didYouNowYouCanMakeAShop}
                        </Alert>
                    </Grid>
                    <Grid item xs={12}>
                           <UserGuidLine/>
                    </Grid>
                    <Grid item xs={12}>
                        <ViewYourOrders/>
                    </Grid>
                </Grid>
            </AppAnimate>
        );
    }
}

const mstp = state => ({
    user: state.user,
});
export default withWidth()(withSnackbar(withRouter(withStyles(Styles)(connect(mstp)(UserDashboard)))));
